import { useGetApiWorkspacesByIdObservabilityFailureSummaryQuery } from '@/model/observability/api.generated';
import type { FailureSummaryResponse } from '@/model/observability/dto.generated';
import { skipToken } from '@reduxjs/toolkit/query/react';

type FailureSummaryArgs = { workspaceId: string; correlationId: string };

export const useFailureSummary = (
  args: FailureSummaryArgs | typeof skipToken,
  options?: { skip?: boolean },
): {
  data: FailureSummaryResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
} => {
  const queryArgs =
    args === skipToken ? skipToken : { id: args.workspaceId, correlationId: args.correlationId };
  const { data, isLoading, isError, isSuccess } =
    useGetApiWorkspacesByIdObservabilityFailureSummaryQuery(queryArgs, options);
  return { data: data?.data, isLoading, isError, isSuccess };
};
